import { ApiError } from '@/api/client';

// Pulls the most useful human-readable message off whatever the API
// (or the network) handed us. Shared by Create and Modify so error
// surfaces look identical.
export function extractApiMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.body && typeof err.body === 'object') {
      const b = err.body as { errorMessage?: string; message?: string };
      if (b.errorMessage) return b.errorMessage;
      if (b.message) return b.message;
    }
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
